import { useNavigate } from 'react-router-dom';
import React, { useState, useEffect } from 'react';

import {
  AccionDetalle,
  IInitialState,
  TipoAccionDetalle,
} from '../Shared/data/FormReducer';
import { IProductos } from '../Interfaces/IProductos';
import { inicioService, sendUserData } from '../Services/Form';
import Loading from '../Utils/Loading';
import Inicio from '../Components/Main/Inicio';
import MainForm from '../Components/Main/MainForm';
import { IUserFromStorage } from '../Interfaces/IUser';
import UploadVideo from './UploadVideo/UploadVideo';

interface IHome {
  state: IInitialState;
  dispatch: React.Dispatch<AccionDetalle>;
}

const Home: React.FC<IHome> = (props) => {
  const [validateLogin, setValidateLogin] = useState(false);
  const [productos, setProductos] = useState<IProductos>();
  const [loading, setLoading] = useState(false);
  const [user, setUser] = useState<IUserFromStorage>();
  
  const navigate = useNavigate();

  useEffect(() => {
    if (localStorage.getItem('user')) {
      let value = localStorage.getItem('user');
      let user = typeof value === 'string' ? JSON.parse(value) : '';
      setUser(user);
    } else {
      navigate('login');
    }
    setValidateLogin(true);
  }, []);

  useEffect(() => {
    if (validateLogin) {
      try {
        setLoading(true);
        sendUserData({
          Correo: user.correo,
          Clave: user.clave,
        })
          .then((response) => {
            props.dispatch({
              type: TipoAccionDetalle.CHANGE_RESPONDIO,
              payload: response.data.data.respondio,
            });
            props.dispatch({
              type: TipoAccionDetalle.CHANGE_NOMBRE,
              payload: user.nombres,
            });
          })
          .finally(() => {
            setLoading(false);
          });

        inicioService({
          UsuarioTestAsesoriaID: user.usuarioTestAsesoriaID,
        }).then((response) => {
          setProductos(response.data.data);
        });
      } catch (error) {
        console.error(error);
      }
    }
  }, [validateLogin]);

  useEffect(() => {
    if (props.state.nombre) {
      setLoading(false);
    }
  }, [props.state]);

  useEffect(() => {
    if (props.state.nombre) {
      if (props.state.respondio) {
        localStorage.setItem('respondio', JSON.stringify(props.state.respondio));
        navigate('/');
      }
    }
  }, [props.state]);

  return (
    <div style={{ width: '97.8vw', height: '100%' }}>
      {loading ? (
        <div
          className="container flex justify-content-center align-items-center"
          style={{ height: '85vh', width: '100%' }}
        >
          <Loading />
        </div>
      ) : (
        <>
          {props.state.respondio && props.state.nombre ? (
            productos && <Inicio productos={productos} />
          ) : (
            <MainForm state={props.state} dispatch={props.dispatch} />
          )}
        </>
      )}
    </div>
  );
};

export default Home;
